module.exports = __webpack_public_path__ + "static/myp-6685ae25bedf0c4a2d6782154a411b46.jpg";